<template>
    <div :class="['splitter','reveal',isFadeOut ? 'fadeout': '']" ref="content">
        <!--
            <slot></slot> 
            {{content}}
        -->        
    </div>
</template>

<script>
import { splitLines }         from "@/utils";
export default {
    //this component is for splitting rows and animating on reveal 
    name: "splitter",
    props: {
        content:{
            default:'',
            type:String
        },
        startDelay:{
            default:0,
            type:Number
        },
        startOnLoad:
        {
            default:false,
            type:Boolean
        },
        contentIndex:
        {
            default:0,
            type:Number
        }
    },
    /*
    render(h)
    {
        const slot = this.$slots.default[0]
        alert(slot.text);
        return slot.text;
    },*/
    data()
    {
        return {
            isFadeOut:false,
            selectedIndex:0
        }
    },
    created()
    {
        //this.sectionData = this.siteData.SECTIONS[this.sectionIndex];
    },
    mounted()
    {
        this.initText(false);
    },
    watch:{
        //contentIndex
        content:function(newVal,oldVal)
        {
            var vm = this;
            var contentEl = vm.$refs.content;
            //contentEl.innerHTML = this.content;  

            contentEl.classList.add("fast");//hide fast

            //fade out and add a small delay before showing again
            vm.isFadeOut = true; //fadeout the component
            setTimeout(() => {          
                contentEl.classList.remove("fast");//hide fast      
                contentEl.classList.remove("active"); //remove the active
                vm.initText(true);                
            }, 100);


            //this.selectedIndex = Number(newVal);
            //alert("init the splitter now");
            //todo:
            //fade out and split back
        },

        itemIndex:function(newVal,oldVal){
            //alert("new = "+newVal);
            this.selectedIndex = Number(newVal);
        }
    },
    methods:
    {
        initText(changeFromWatch)
        {      
            var contentEl = this.$refs.content;

            //slight delay to avoid unmatching dom line splits
            setTimeout(() => {
                contentEl.innerHTML = this.content;     
                splitLines(this.startDelay,1,contentEl,'splLine','splLineText');                 
            }, 100);

            if(this.startOnLoad || changeFromWatch){
                if(contentEl.classList.contains("active")==false){
                    setTimeout(() => {
                       contentEl.classList.add("active"); 
                    }, 500);
                }
            }
            
            this.isFadeOut = false;
        },
        setItem(index)
        {
            //alert(index);
            //this.selectedIndex = index;
            //this.$emit('item-change',index);
        }
    },
};
</script>

<style>
    .splitter
    {
        opacity: 1;transition:opacity ease-in 0.2s;
    }
    .splitter.fadeout
    {
        opacity: 0;
    }
    .splLine
    {
        overflow: hidden;
    }   
    .splLine .splLineText
    {
        position:relative;
        top:0px;
    }
    .splitter .splLine .splLineText
    {      
        transition-duration: 1s;
        transition-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);    
        transition-delay:calc((var(--start_delay) *1s) + (0.15s * var(--line_index)));
        transform: translateY(50px);
        opacity: 0;
    }
    .splitter.fast .splLine .splLineText
    {      
        transition-duration: 0.1s !important;
        transition-delay:0 !important;
        opacity: 0;
    }

    .splitter.active .splLine .splLineText
    {      
        transform: translateY(0px);
        opacity: 1;
    }


</style>